import RecentSearchesContainer from './Container';
import reducer from './reducer';
import saga from './saga';

export { reducer as recentSearchesReducer, saga as recentSearchesSaga };
export default RecentSearchesContainer;
